export default "__VITE_ASSET__65439865__"